<template>
  <v-row id="report" class="ddblack">
    <v-col cols="12"  v-if="clinic">
      <span class="d-block py-6 pb-1 text-h5">Data report for: {{ clinic }}</span>
      <span class="d-block py-1 text-subtitle-1 ddgrey--text">Data shown for {{ formatDateFilter() }}</span>
    </v-col>

    <v-col cols="12">
      <ChatsPercentages :chatsData="data.stats" :loading="loading"/>
    </v-col>

    <v-col cols="12">
      <MostCommonlyQuestion :chatsData="data.mostCommonlyQuestion" :loading="loading"/>
    </v-col>

    <v-col cols="12">
      <ChatsStats :chatsData="data.chats" :loading="loading"/>
    </v-col>

    <v-col cols="12" md="6">
      <ExistingVsNewOnes :chatsData="data.existingVsNewOnes" :loading="loading"/>
    </v-col>

    <v-col cols="12" md="6">
      <ChatsByDevice :chatsData="data.devices" :loading="loading"/>
    </v-col>

    <v-col cols="12" md="6">
      <TopQuestions :chatsData="data.questions" :loading="loading"/>
    </v-col>

    <v-col cols="12" md="6">
      <TopLocations :chatsData="data.locations" :loading="loading"/>
    </v-col>
  </v-row>
</template>

<script>
import ChatsStats from '@/components/dashboard/widgets/ChatsStats';
import ExistingVsNewOnes from '@/components/dashboard/widgets/ExistingVsNewOnes';
import ChatsPercentages from '@/components/dashboard/widgets/ChatsPercentages';
import TopQuestions from '@/components/dashboard/widgets/TopQuestions';
import TopLocations from '@/components/dashboard/widgets/TopLocations';
import ChatsByDevice from '@/components/dashboard/widgets/ChatsByDevice';
import MostCommonlyQuestion from '@/components/dashboard/widgets/MostCommonlyQuestion';


/**
* This component contains all the Widgets of the AI Chat's Data Report.
*/

export default {
  name: 'AIChatDataReport',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    clinic: {
      type: String,
      default: ""
    },
    account: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({
        chats: {},
        existingVsNewOnes: {},
        stats: {},
        questions: {},
        locations: {
          locations: [],
          topLocations: []
        },
        devices: {},
        mostCommonlyQuestion: ''
      })
    },
    dateFilter: {
      type: Object,
      default: () => ({
        from: false,
        to: false
      })
    },
  },
  methods: {
    formatDateFilter() {
      const format = (date) => `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
      if (this.dateFilter.from && this.dateFilter.to && this.dateFilter.from !== this.dateFilter.to) {
        return `${format(this.dateFilter.from)} - ${format(this.dateFilter.to)}`;
      } else if (this.dateFilter.from) {
        return format(this.dateFilter.from);
      } else return 'all time';
    },
  },
  components: {
    ChatsStats,
    ExistingVsNewOnes,
    ChatsPercentages,
    TopQuestions,
    TopLocations,
    ChatsByDevice,
    MostCommonlyQuestion,
  }
}
</script>
